export const CountryCode = {
  MX: '+52',
};
